export default __webpack_public_path__ + "static/media/wellWishes.2311bc01.jpg";